import {
  UPDATE_HEADER_DATA,
  CANDIDATE_PROFILE,
  CANDIDATE_PROFILE_ERROR,
  CANDIDATE_PROFILE_RESET
} from '../mutations';

const initialState = {
  profile: null,
  profileError: null,
  headerData: {}
};

export default function candidateReducer(state = initialState, action) {
  switch (action.type) {
    case CANDIDATE_PROFILE:
      return { ...state, profile: action.payload, profileError: null };
    case CANDIDATE_PROFILE_ERROR:
      return { ...state, profileError: action.payload };
    case CANDIDATE_PROFILE_RESET:
      // VTS-562: clear cached profile on logout / user change so a different
      // candidate never sees the prior user's data (TS-032/TS-033).
      return { ...state, profile: null, profileError: null };
    case UPDATE_HEADER_DATA:
      return { ...state, headerData: { ...state.headerData, ...action.payload } };
    default:
      return state;
  }
}
